/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 vangard1.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/vangard1.glb");
	return (
		<group {...props} dispose={null}>
			<group position={[208, 40, 7.8]} rotation={[Math.PI / 2, 0, 1.5]}>
				<mesh
					geometry={nodes.Mesh_1.geometry}
					material={materials["Velvet texture.006"]}
				/>
				<mesh
					geometry={nodes.Mesh_1_1.geometry}
					material={materials["shirts_FRONT_1828.003"]}
				/>
				<mesh
					geometry={nodes.Mesh_1_2.geometry}
					material={materials["Material.001"]}
				/>
				<mesh
					geometry={nodes.Mesh_1_3.geometry}
					material={materials["Material.003"]}
				/>
				<mesh
					geometry={nodes.Mesh_1_4.geometry}
					material={materials["Material.025"]}
				/>
				<mesh
					geometry={nodes.Mesh_1_5.geometry}
					material={materials["Material.026"]}
				/>
			</group>
		</group>
	);
}

useGLTF.preload("models/vangard1.glb");
